export const IMAGE_EXTENSIONS = ['image/jpg', 'image/png', 'image/bmp', 'image/jpeg'];

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
